import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({ message = 'No data available for this period' }) => (
    <div className="clinic-dashboard-empty">
        <Inbox size={28} className="clinic-dashboard-empty-icon" />
        <span className="clinic-dashboard-empty-text">{message}</span>
    </div>
);

export default EmptyState;
